type StorageArea = 'local' | 'session'

const getStorage = (storageArea: StorageArea): Storage | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const storage = storageArea === 'local' ? window.localStorage : window.sessionStorage
    if (!storage || typeof storage.getItem !== 'function') {
      return null
    }

    return storage
  } catch {
    return null
  }
}

export const readStorage = (storageArea: StorageArea, key: string): string | null => {
  const storage = getStorage(storageArea)
  if (!storage) {
    return null
  }

  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

export const writeStorage = (storageArea: StorageArea, key: string, value: string): boolean => {
  const storage = getStorage(storageArea)
  if (!storage) {
    return false
  }

  try {
    storage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const removeStorage = (storageArea: StorageArea, key: string): boolean => {
  const storage = getStorage(storageArea)
  if (!storage) {
    return false
  }

  try {
    storage.removeItem(key)
    return true
  } catch {
    return false
  }
}

export const readBooleanStorage = (storageArea: StorageArea, key: string, fallback = false): boolean => {
  const rawValue = readStorage(storageArea, key)

  if (rawValue === null) {
    return fallback
  }

  if (rawValue === 'true') {
    return true
  }

  if (rawValue === 'false') {
    return false
  }

  try {
    const parsedValue = JSON.parse(rawValue)
    return typeof parsedValue === 'boolean' ? parsedValue : fallback
  } catch {
    return fallback
  }
}
